<template>
  <div class="content-wrapper">
    <div class="user">
      <!-- ========== 头部区域（已优化布局） ========== -->
      <div class="head">
        <div class="head-icon head-icon-isBeta">
          <img :src="userUrl" alt="" />
          <input type="file" accept=".jpg,.jpeg,.png,.bmp,.tif,.tiff,.webp,.svg" style="display: none" />
        </div>
        <div class="head-info">
          <div class="head-name">
            <!-- 修改点：使用本地 nickNameDisplay -->
            <p class="dot name">{{ nickNameDisplay }}</p>
            <div class="edit" @click="nicknameDialogVisible = true" v-if="from !== 'mobile'">
              <el-tooltip content="修改昵称" placement="top">
                <span class="edit-icon"></span>
              </el-tooltip>
            </div>
          </div>
          <div class="identity-row">
            <!-- 修改点：使用本地 gradeDisplay -->
            <div class="grade-tag" @click="openGradeDialog">
              {{ gradeDisplay }}
            </div>
            <div class="member-area">
              <span class="member-badge" :class="{ 'is-member': memberStatus === '会员' }">
                {{ memberStatus }}
              </span>
              <button class="upgrade-vip-btn" @click="toVipSubscription">
                开通会员
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- ========== 操作区域 ========== -->
      <div class="actions" v-if="from !== 'mobile'">
        <div class="selecttheme selecttheme_opacity"></div>
        <div class="themes">
          <div class="title">
            <img class="title-icon" :src="getImage('theme.png')" />
            <p class="title-text">主题模式</p>
          </div>
          <div class="guide">
            <el-tooltip content="浅色" placement="top">
              <div v-show="theme === 'light'" @click="switchTheme('dark')">
                <img class="icon" :src="getImage('dark.svg')" />
              </div>
            </el-tooltip>
            <el-tooltip content="深色" placement="top">
              <div v-show="theme === 'dark'" @click="switchTheme('light')">
                <img class="icon" :src="getImage('light.svg')" />
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="obstruct">
          <p class="obstruct-icon"></p>
        </div>
        <div class="action flex flex-x-between" @click="classDialogVisible = true">
          <div class="flex flex-x-between flex-y-center">
            <img class="action-icon icon-collect" :src="getImage('grade.svg')" />
            <p class="action-text"><span>年级信息</span></p>
          </div>
        </div>
        <div @click="toOrderList" class="action flex flex-x-between">
          <div class="flex flex-x-between flex-y-center">
            <img class="action-icon icon-order" :src="getImage('order.svg')" />
            <p class="action-text"><span>我的订单</span></p>
          </div>
        </div>
        <div @click="toDownload" class="action flex flex-x-between" v-if="isShowDownload()">
          <div class="flex flex-x-between flex-y-center">
            <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
              <path fill="currentColor" d="M8.315 2.347v5.095h6.582V1.23zm0 11.325 6.582 1.097V8.562H8.315zM1.358 7.44h5.564V2.532l-5.564.944zm0 5.121 5.564.928V8.562H1.358z"></path>
            </svg>
            <p class="action-text"><span>下载客户端</span></p>
          </div>
        </div>
        <!-- 新增：账号管理 -->
        <div @click="accountDialogVisible = true" class="action flex flex-x-between">
          <div class="flex flex-x-between flex-y-center">
            <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
              <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
              <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
            </svg>
            <p class="action-text"><span>账号管理</span></p>
          </div>
        </div>
        <div @click="toAboutUs" class="action flex flex-x-between">
          <div class="flex flex-x-between flex-y-center">
            <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
            </svg>
            <p class="action-text"><span>关于我们</span></p>
          </div>
        </div>
        <div @click="toUserGuide" class="action flex flex-x-between">
          <div class="flex flex-x-between flex-y-center">
            <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
            </svg>
            <p class="action-text"><span>使用指引</span></p>
          </div>
        </div>
        <div @click="toSuggestion" class="action flex flex-x-between">
          <div class="flex flex-x-between flex-y-center">
            <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8.5 16a.5.5 0 0 1-.5-.5V8.707L5.854 10.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 8.707V15.5a.5.5 0 0 1-.5.5zM1.5 8a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H1.5z"/>
            </svg>
            <p class="action-text"><span>改进建议</span></p>
          </div>
        </div>
        <div @click="logoutDialogVisible = true" class="action flex flex-x-between">
          <div class="flex flex-x-between flex-y-center">
            <img class="action-icon icon-exit" :src="getImage('exit.svg')" />
            <p class="action-text"><span>退出登录</span></p>
          </div>
        </div>
      </div>
    </div>
    <!-- ========== 对话框区域 ========== -->
    <el-dialog top="30vh" title="提示" :visible.sync="logoutDialogVisible" class="logoutDialog" width="30%" :append-to-body="true">
      <div class="warn-info">
        <i class="el-icon-warning logout-warning"></i>
        确定退出系统吗？
      </div>
      <span slot="footer" class="dialog-footer base-button">
        <button @click="logoutDialogVisible = false">取 消</button>
        <button type="primary" @click="logout">确 定</button>
      </span>
    </el-dialog>
    <el-dialog class="nickname-dialog" title="编辑昵称" :visible.sync="nicknameDialogVisible" :append-to-body="true" width="30%" top="28vh">
      <div class="nickname-change">
        <el-input maxlength="10" placeholder="请输入昵称" v-model="nickname"></el-input>
        <span class="count">{{ nickname.length }}/10</span>
      </div>
      <span slot="footer" class="dialog-footer base-button">
        <button type="primary" @click="updateNickName">确 定</button>
      </span>
    </el-dialog>
    <el-dialog class="grade-dialog" title="选择年级身份" :visible.sync="classDialogVisible" :append-to-body="true" top="10vh" width="528px">
      <grade @setGrade="setGrade"></grade>
      <span slot="footer" class="dialog-footer base-button">
        <button @click="classDialogVisible = false">取 消</button>
        <button type="primary" @click="selectGrade">确 定</button>
      </span>
    </el-dialog>
    <!-- 新增：账号管理对话框 -->
    <el-dialog title="账号管理" :visible.sync="accountDialogVisible" width="400px" top="25vh" :append-to-body="true" class="account-dialog">
      <div class="account-info">
        <div class="info-row">
          <span class="label">手机号码</span>
          <span class="value">{{ maskedPhone }}</span>
          <button class="change-phone-btn" @click="changePhone">变更</button>
        </div>
        <div class="divider"></div>
        <button class="delete-account-btn" @click="deleteAccount">注销账号</button>
      </div>
      <span slot="footer" class="dialog-footer">
        <button @click="accountDialogVisible = false">关闭</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store/index";
import userUrl from "@/assets/image/user.svg";
import Grade from "./grade.vue";
import { mapState } from "vuex";
import { logout } from "@/api/login";
import { showGrade, updateGrade, showNickName, updateNickName, queryOrders } from "@/api/home";
import { isElectronEnv } from "@/utils/tool";
export default {
  name: "userInfo",
  data() {
    return {
      userUrl,
      logoutDialogVisible: false,
      nicknameDialogVisible: false,
      classDialogVisible: false,
      accountDialogVisible: false,
      nickname: "",
      selectedGrade: "",
      memberStatus: "",
      orders: [],
      maskedPhone: "",
      // 新增本地状态，用于显示，避免 Vuex 频繁更新导致的闪烁
      nickNameDisplay: "加载中...",
      gradeDisplay: "加载中..."
    };
  },
  components: { Grade },
  props: ["from"],
  computed: {
    // 修改点：移除 user 映射，切断 Vuex 响应式依赖
    ...mapState(["theme"]),
  },
  created() {
    this.initData();
  },
  activated() {
    this.initData();
  },
  methods: {
    initData() {
      // 修改点：初始化本地显示数据
      this.nickNameDisplay = this.$store.state.user?.name || '未设置';
      this.gradeDisplay = this.$store.state.user?.grade || '未设置';
      
      this.showUserGrade();
      this.showUserNickName();
      this.getMemberInfo();
      this.getPhoneNumber();
    },
    toSuggestion() {
      window.open('https://scntx8g1jm13.feishu.cn/share/base/form/shrcnc0uTYpAUVDM4VzNWCzJxRh', '_blank');
    },
    toAboutUs() {
      this.$router.push('/about-us');
    },
    toUserGuide() {
      this.$router.push('/user-guide');
    },
    toOrderList() {
      this.$router.push('/pay/orders');
    },
    async getMemberInfo() {
      try {
        const { data } = await queryOrders();
        this.memberStatus = data.is_member ? '会员' : '非会员';
        this.orders = data.order_info || [];
      } catch (error) {
        console.error('查询会员信息失败：', error);
        this.memberStatus = '未知状态';
      }
    },
    // 修改点：获取手机号时不再使用 mapState 的 user，而是直接读取 store
    getPhoneNumber() {
      const phone = this.$store.state.user?.phoneNumber || '';
      if (phone) {
        this.maskedPhone = phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      } else {
        this.maskedPhone = '未绑定';
      }
    },
    toVipSubscription() {
      this.$router.push('/pay/vip-subscription');
    },
    isShowDownload() {
      return !isElectronEnv();
    },
    async showUserNickName() {
      let { data } = await showNickName();
      if (!data) return;
      this.nickname = data.nickname;
      if (!this.nickname) this.nickname = "用户_rfWpjk";
      
      // 修改点：同步更新本地显示状态和 Vuex
      this.nickNameDisplay = this.nickname;
      store.commit("setUser", { name: this.nickname });
    },
    async updateNickName() {
      let nickname = this.nickname;
      if (!nickname) {
        this.$message.warning("昵称不能为空");
        return;
      }
      let res = await updateNickName({ nickname });
      this.nicknameDialogVisible = false;
      if (!res) return;
      if (res.status === 200) {
        this.$message.success(res.data.message);
        // 修改点：同步更新本地显示状态和 Vuex
        this.nickNameDisplay = nickname;
        store.commit("setUser", { name: nickname });
      } else {
        this.$message.error("更新昵称失败！");
      }
    },
    async showUserGrade() {
      let { data } = await showGrade();
      if (!data) return;
      store.commit("setLevel", data.grade);
      store.commit("setUser", { grade: data.grade });
      // 修改点：同步更新本地显示状态
      this.gradeDisplay = data.grade;
    },
    async updateGrade() {
      let selectedGrade = this.selectedGrade;
      let res = await updateGrade({ grade: selectedGrade });
      if (res.status === 200) {
        this.$message.success(res.data.message);
        store.commit("setUser", { grade: selectedGrade });
        store.commit("setLevel", selectedGrade);
        // 修改点：同步更新本地显示状态
        this.gradeDisplay = selectedGrade;
      } else {
        this.$message.error("更新年级身份信息失败！");
      }
    },
    async selectGrade() {
      this.classDialogVisible = false;
      this.updateGrade();
    },
    openGradeDialog() {
      if (this.from === 'mobile') return;
      this.classDialogVisible = true;
    },
    setGrade(grade) {
      this.selectedGrade = grade;
    },
    getImage(imgname) {
      return require(`@/assets/image/theme/` + this.theme + `/${imgname}`);
    },
    switchTheme(theme) {
      if (this.theme === theme) return;
      this.$store.commit("setTheme", theme);
    },
    changePhone() {
      this.$message.info("修改手机号功能开发中");
    },
    deleteAccount() {
      this.$confirm('注销账号后所有数据将被永久删除且无法恢复，确定要继续吗？', '危险操作', {
        confirmButtonText: '确定注销',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      }).then(async () => {
        try {
          this.accountDialogVisible = false;
          this.logout();
        } catch (error) {
          this.$message.error('注销失败，请稍后再试');
        }
      }).catch(() => {});
    },
    async logout() {
      let res = await logout();
      this.logoutDialogVisible = false;
      store.commit("removeUser");
      store.commit("removeToken");
      store.commit("CLEAR_MESSAGE");
      this.$router.push('/login');
    },
    selectChatByAvatar(name) {
      const content = `<span contenteditable="false"><a>@${name}</a></span>&nbsp;`;
      this.$refs.chatFooter.$refs.inputRef.innerHTML += content;
      this.setCaret(this.$refs.chatFooter.$refs.inputRef);
    },
    setCaret(el) {
      const range = document.createRange();
      const sel = window.getSelection();
      const len = el.childNodes.length - 1;
      const lastChildNode = el.childNodes[len];
      range.setStart(lastChildNode, 0);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
    },
    toDownload() {
      this.$router.push('/downloadDesk');
    }
  }
};
</script>

<style lang="scss" scoped>
/* ========== 整体容器 ========== */
.user {
  padding: 24px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 24px;
  width: 280px;
  box-shadow: 0 12px 40px rgba(92, 95, 250, 0.15), 0 4px 12px rgba(0, 0, 0, 0.05);
  background: linear-gradient(135deg, #7f7fd5 0%, #86a8e7 50%, #91eae4 100%);
  position: relative;
  z-index: 2046;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 16px 48px rgba(92, 95, 250, 0.25), 0 6px 20px rgba(0, 0, 0, 0.08);
  }

  /* ========== 头部优化 ========== */
  .head {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 14px;
    margin-bottom: 20px;
    padding: 0 4px;
    z-index: 99;

    .head-icon {
      position: relative;
      border: 2px solid rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: transform 0.2s ease, box-shadow 0.2s ease;

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }

      &.head-icon-isBeta {
        width: 48px;
        height: 48px;
        border-color: rgba(255, 255, 255, 0.6);
        box-shadow: 0 0 12px rgba(255, 255, 255, 0.3);

        &:hover {
          transform: scale(1.05);
          box-shadow: 0 0 18px rgba(255, 255, 255, 0.5);
        }
      }
    }

    .head-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .head-name {
        display: flex;
        align-items: center;
        gap: 8px;

        .name {
          font-size: 16px;
          font-weight: 700;
          color: #fff;
          margin: 0;
          max-width: 130px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
        }

        .edit {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 6px;
          background: rgba(255, 255, 255, 0.2);
          cursor: pointer;
          transition: background 0.2s, transform 0.2s;

          &:hover {
            background: rgba(255, 255, 255, 0.4);
            transform: scale(1.1);
          }

          .edit-icon {
            width: 14px;
            height: 14px;
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABACAMAAAByderSAAAAk1BMVEX///////////////////////////9HcEz///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+SBwAeAAAAMXRSTlOyQ5yQWYULAOgW26chb5u23npOvyxCZMfGzcPCOOHQvDfP1I/XHaPB5cusyrXJt9HkovBq5AAAAdxJREFUWMPt18eW4jAQRuGLU5UQDmToPN2T8/s/3SwIlkDYwr0c/iVG3zFUqWQj7w034T8VjCneIyxyC6SjoYLJ2SeZDBJMQpvRAMEDTgniATudVgGCaCAtRCQ7J/qFT1/GPw5AiOgVzDdV3RyAANEnmM+qquO07aUdYSeRgkn4qqqNcT7bEXmcYBJ4Um3qTM6IRYxgEmCuTY11b0JWAGWEsC/jUw1M3QsFQNIvHPrgAYCZe6mKEtpG2u0qd0cBpH2C04nG+vWTmVsMIlpZlng/ZOT1FBHAsRFL0wJJ0SmcAEfCrsweaNuaKOBIwNsGgKxzXwQAkZkFYK36+NMFQkIQ2I/KtarqnQsEhAuAiCyrtaqq3mWdM+oyIDK6/6iqTdY5JzsBoL6fZ52zug/wqhASBgAnQnk94AtmAOALpdfwcYAvJADmOsATCndwxAKeMOF0IEYAnvAQ/l434AlZ4OmgF/CE0j1IYgFPyAGKKwFPqAB7LeAJ58WMAFzhvJgxgCss3PNUREwWA5zdQy4ixWSZlaklCnCFwgJ8rz+M3fzOwzGhf3IFPKufLRdiQ2dWUcHWWz+eczEvwQlTMT+u/tv86VjfTgF/yhXLdKuPzeuvzXNNZ+zs9p51E0L5BzcBZyp0Cm2QAAAAAElFTkSuQmCC) no-repeat center;
            background-size: contain;
          }
        }
      }

      .identity-row {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;

        .grade-tag {
          background: rgba(255, 255, 255, 0.15);
          color: #fff;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;

          &:hover {
            background: rgba(255, 255, 255, 0.25);
          }
        }

        .member-area {
          display: flex;
          align-items: center;
          gap: 8px;

          .member-badge {
            font-size: 13px;
            color: rgba(255, 255, 255, 0.8);
            display: flex;
            align-items: center;
            gap: 4px;

            &::before {
              content: '';
              display: inline-block;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: #94a3b8;
              opacity: 0.7;
            }

            &.is-member::before {
              background: #4ade80;
              box-shadow: 0 0 6px rgba(74, 222, 128, 0.5);
              opacity: 1;
            }
          }

          .upgrade-vip-btn {
            padding: 5px 12px;
            background: linear-gradient(135deg, #fbbf24, #f59e0b);
            color: #fff;
            border: none;
            border-radius: 20px;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;
            box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
            transition: all 0.2s;

            &:hover {
              background: linear-gradient(135deg, #fcd34d, #fbbf24);
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
            }
          }
        }
      }
    }
  }

  /* ========== 操作区域 ========== */
  .actions {
    position: relative;
    margin-top: -12px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 16px 12px;
    gap: 8px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(20px);
    border-radius: 20px;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5), 0 6px 20px rgba(0, 0, 0, 0.05);

    .themes {
      width: 100%;
      padding: 6px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 12px;
      background: rgba(0, 0, 0, 0.02);
      margin-bottom: 4px;

      .title {
        display: flex;
        align-items: center;
        gap: 10px;

        .title-icon {
          width: 18px;
          height: 18px;
          opacity: 0.8;
        }

        .title-text {
          color: var(--txt-default-color-2);
          font-size: 13px;
          font-weight: 500;
        }
      }

      .guide {
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        padding: 6px 10px;
        border-radius: 8px;
        transition: background 0.2s;

        &:hover {
          background: rgba(0, 0, 0, 0.05);
        }

        .icon {
          width: 18px;
          height: 18px;
          transition: transform 0.2s;
        }

        &:active .icon {
          transform: scale(0.9);
        }
      }
    }

    .obstruct {
      width: 100%;
      height: 1px;
      margin: 8px 0;
      background: linear-gradient(to right, transparent, var(--bg-color-3), transparent);
    }

    .action {
      box-sizing: border-box;
      padding: 10px 12px;
      gap: 10px;
      width: calc(50% - 4px);
      display: flex;
      align-items: center;
      cursor: pointer;
      border-radius: 14px;
      transition: all 0.25s ease;
      background: transparent;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--hover-bg-color-1);
        opacity: 0;
        transition: opacity 0.25s;
        border-radius: 14px;
        z-index: -1;
      }

      .action-icon {
        width: 18px;
        height: 18px;
        color: var(--txt-default-color);
        transition: transform 0.2s;
        flex-shrink: 0;
      }

      .action-text {
        font-size: 13px;
        font-weight: 500;
        color: var(--txt-default-color-2);
        transition: color 0.2s, font-weight 0.2s;
        white-space: nowrap;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.02);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);

        &::before {
          opacity: 1;
        }

        .action-icon {
          transform: scale(1.1);
        }

        .action-text {
          font-weight: 600;
          color: var(--txt-default-color);
        }
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}

/* ========== 对话框美化 ========== */
.el-dialog__body {
  padding: 24px;
}

.nickname-dialog,
.logoutDialog {
  ::v-deep .el-dialog {
    border-radius: 28px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    border: none;
  }

  ::v-deep .el-dialog__header {
    padding: 24px 24px 0;
    font-weight: 700;
    font-size: 18px;
    color: #1e293b;
  }

  ::v-deep .el-dialog__body {
    padding: 20px 24px 10px;
  }

  ::v-deep .el-dialog__footer {
    padding: 12px 24px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    button {
      border-radius: 24px;
      padding: 8px 24px;
      font-weight: 600;
      border: 2px solid #e2e8f0;
      background: #fff;
      color: #475569;
      transition: all 0.2s;

      &:hover {
        background: #f8fafc;
        border-color: #cbd5e1;
      }
    }

    button[type="primary"] {
      background: linear-gradient(135deg, #7f7fd5, #86a8e7);
      border: none;
      color: #fff;
      box-shadow: 0 4px 12px rgba(127, 127, 213, 0.3);

      &:hover {
        background: linear-gradient(135deg, #6b6bd4, #7b9ee0);
        box-shadow: 0 6px 16px rgba(127, 127, 213, 0.4);
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}

.warn-info {
  display: flex;
  align-items: center;
  margin: 5% 0 8%;
  font-size: 16px;
  color: #334155;

  .logout-warning {
    font-size: 32px;
    color: #f59e0b;
    margin-right: 12px;
    animation: pulse-warning 2s infinite;
  }
}

@keyframes pulse-warning {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.15); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
}

.grade-dialog {
  ::v-deep .el-dialog {
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }

  ::v-deep .el-dialog__header {
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    background: #f8fafc;
    font-weight: 700;
  }

  ::v-deep .el-dialog__footer {
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
    padding: 16px 24px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    button {
      border-radius: 24px;
      padding: 8px 24px;
      font-weight: 600;
      border: 2px solid #e2e8f0;
      background: #fff;
      color: #475569;

      &:hover {
        background: #f8fafc;
      }
    }

    button[type="primary"] {
      background: linear-gradient(135deg, #7f7fd5, #86a8e7);
      border: none;
      color: #fff;
      box-shadow: 0 4px 12px rgba(127, 127, 213, 0.3);

      &:hover {
        box-shadow: 0 6px 16px rgba(127, 127, 213, 0.4);
        transform: translateY(-1px);
      }
    }
  }
}

/* ========== 账号管理对话框样式 ========== */
.account-dialog {
  ::v-deep .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12);
  }

  .account-info {
    .info-row {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 8px;

      .label {
        font-weight: 500;
        color: #64748b;
        font-size: 14px;
        white-space: nowrap;
      }

      .value {
        font-size: 16px;
        font-weight: 600;
        color: #1e293b;
        flex: 1;
        text-align: left;
      }

      .change-phone-btn {
        margin-left: auto;
        padding: 6px 16px;
        border-radius: 8px;
        border: 1px solid #cbd5e1;
        background: #fff;
        cursor: pointer;
        font-size: 13px;
        color: #475569;
        transition: all 0.2s;

        &:hover {
          background: #f1f5f9;
          border-color: #94a3b8;
          color: #1e293b;
        }
      }
    }

    .divider {
      height: 1px;
      background: #e2e8f0;
      margin: 16px 0;
    }

    .delete-account-btn {
      width: 100%;
      padding: 12px;
      background: #ef4444;
      color: #fff;
      border: none;
      border-radius: 12px;
      font-weight: 600;
      font-size: 14px;
      cursor: pointer;
      transition: background 0.2s, transform 0.1s;

      &:hover {
        background: #dc2626;
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  ::v-deep .dialog-footer {
    text-align: right;
    padding: 12px 20px 16px;

    button {
      border-radius: 8px;
      padding: 8px 24px;
      font-weight: 500;
      border: 1px solid #e2e8f0;
      background: #fff;
      color: #475569;
      transition: all 0.2s;

      &:hover {
        background: #f8fafc;
      }
    }
  }
}
</style>